


































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppFormCheckbox extends Vue {
  @Prop(Boolean) readonly value!: boolean
  @Prop(String) readonly label!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: [Number, String], default: '289' }) readonly width!: number | string
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Emit('input')
  switchValue (e: MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
    return !this.value
  }
}
